import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { useCart, type CartItem } from '@/contexts/CartContext';
import type { CartTotals } from '@/lib/promotions';

/** Final price of a cart line: quantity tier or promo code — the higher discount wins. */
export function useLinePricing(item: CartItem, totals: CartTotals) {
  const line = totals.lines[item.id];
  const listTotal = item.price * item.quantity;
  return {
    line,
    discounted: !!line?.source,
    unit: line?.source ? line.unit : item.price,
    lineTotal: line?.source ? line.lineTotal : listTotal,
    listUnit: item.price,
    listTotal,
  };
}

/** "Mengenrabatt −10 %" or "Code XYZ −15 %" for one line. */
export const LineDiscountLabel: React.FC<{ item: CartItem; totals: CartTotals; className?: string }> = ({ item, totals, className }) => {
  const { t } = useLanguage();
  const { promoCode } = useCart();
  const line = totals.lines[item.id];
  if (!line?.source) return null;
  const m = t.shop.miniCart;
  const text = line.source === 'tier'
    ? m.tierActive.replace('{pct}', String(line.percent))
    : m.codeLineActive.replace('{code}', promoCode?.code ?? '').replace('{pct}', String(line.percent));
  return <p className={className ?? 'text-xs font-semibold text-primary'} data-line-discount={line.source}>{text}</p>;
};
